import { BuyerCancelRow, PayMode } from 'services/reportsApi';

const HEADERS = [
  'PayUp ID',
  'Batch #',
  'Vendor',
  'Property',
  'Amount',
  'Mode',
  'Canceled On',
  'Canceled By',
  'Reason',
] as const;

const PAY_MODE_LABEL: Record<PayMode, string> = {
  ach: 'ACH',
  check: 'Check',
  debit_card: 'Debit card',
  digital_check: 'Digital check',
};

const fmtDate = (iso: string | null): string => {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toISOString().slice(0, 10);
};

const escapeCell = (raw: string | number | null | undefined): string => {
  if (raw === null || raw === undefined) return '';
  const s = String(raw);
  if (/[",\r\n]/.test(s)) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
};

export const toCsv = (rows: BuyerCancelRow[]): string => {
  const lines = [HEADERS.join(',')];
  for (const r of rows) {
    lines.push(
      [
        escapeCell(r.payup_transfer_number),
        escapeCell(r.batch_number ?? ''),
        escapeCell(r.vendor_name ?? ''),
        escapeCell(r.property_name ?? ''),
        escapeCell(r.amount),
        escapeCell(PAY_MODE_LABEL[r.pay_mode] ?? r.pay_mode),
        escapeCell(fmtDate(r.canceled_at)),
        escapeCell(r.canceled_by_user_name ?? ''),
        escapeCell(r.cancellation_notes ?? ''),
      ].join(',')
    );
  }
  return lines.join('\r\n');
};

export const csvFilename = (now: Date = new Date()): string => {
  const yyyy = now.getUTCFullYear();
  const mm = String(now.getUTCMonth() + 1).padStart(2, '0');
  const dd = String(now.getUTCDate()).padStart(2, '0');
  return `buyer-cancellations-${yyyy}-${mm}-${dd}.csv`;
};

export const triggerCsvDownload = (csv: string, filename: string): void => {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
